import ApiBase from '../ApiBase';

class QuizSubmission extends ApiBase {
    route = '/exhibitors/quiz-submissions';
}

export default new QuizSubmission();
